import axios from "./TddCustomAxios";
import { trackPromise } from "react-promise-tracker";
import {renewAccessTokenIfGoingExpire} from '../../../api/authApi'
import { getErrorFailure } from "../../../error/errorHandlingSlice";
import {
  getFailure,
  resetSliceState,
  getElementSuggestionsSuccess,
  getSuccess,
} from "../feature-bundle/defects/element-section/elementSectionSlice.js";


export const fetchSubCategoryElementList = (request) => async (dispatch) => {
  try {
    const tokenHeader = await renewAccessTokenIfGoingExpire();
    const response = await trackPromise(
      axios({
        method: "get",
        url: `/element/fetch-elementList/${request.projectIdent}/${request.ident}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: tokenHeader,
        },
      })
    );
    if (response.data.type === "ERROR") {
      dispatch(getFailure(response.data));
    } else {
      dispatch(getElementSuggestionsSuccess(response.data));
    }
  } catch (error) {
    if (error.response || error.request) {
      let payload = {};
      payload = {
        type: "ERROR",
        messages:
          "OOPS! Something might have went wrong, Please try again.If the issue still exists, Please contact guru@taeurope.com",
        error: error?.response?.data,
        responseError: "true",
      };
      dispatch(getErrorFailure(payload));
    }
  }
};
